import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import i18n from './plugins/i18n'
import './plugins/vue-mask'
import './plugins/vuelidate'
import './plugins/vue-google-maps'
import './plugins/vue-frag'
import '@/scss/global.scss'

import VueSimpleAlert from 'vue-simple-alert'
Vue.use(VueSimpleAlert)

import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false

export default new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: (h) => h(App)
}).$mount('#app')
